export default __webpack_public_path__ + "static/media/minusRect.254bb6da.svg";